import { useQuery } from "@tanstack/react-query";

import { fetchUnreadNotificationCount } from "./fetchNotifications";
import { notificationQueryKeys } from "./query-keys";
import { NOTIFICATION_STALE_TIME_MS } from "../constants";

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: notificationQueryKeys.unreadCount(),
    queryFn: fetchUnreadNotificationCount,
    staleTime: NOTIFICATION_STALE_TIME_MS,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
}
